import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowDownIcon } from '@getgo/chameleon-icons/react';
import { IconButton } from '@getgo/chameleon-web/react';
import { useTranslation } from 'react-i18next';
import classes from './NewMessageIndicator.module.scss';
const NewMessageIndicator = ({ onClick }) => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: classes.newMessageIndicator }, { children: _jsx(IconButton, Object.assign({ title: t('New events'), className: classes.newMessageIndicatorButton, onClick: onClick }, { children: _jsx(ArrowDownIcon, {}, void 0) }), void 0) }), void 0));
};
export default NewMessageIndicator;
//# sourceMappingURL=NewMessageIndicator.js.map